import * as React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

// components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Toolbar from '@mui/material/Toolbar';

import LinearProgress from "@mui/material/LinearProgress";

import IconButton from '@mui/material/IconButton';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { alpha } from '@mui/material/styles';
import DeleteDialog from '../../../../components/DeleteDialog';
// import AppLink from '../../components/AppLink';
import PrescriptionListWidget from './prescription-list.component';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';

import { putMessage } from '../../../app/store/actions';
//others
import api, { PagenatedRequest } from '../../../../api/medAppApi'
import { Prescription} from "../../../../models";
import pluralize from 'pluralize';



const PrescriptionsPage = () => {
    const dispatch = useDispatch();
    const [prescriptions, setPrescriptions] = React.useState<Prescription[]>([])
    const [page, setPage] = React.useState(1);
    const [total, setTotal] = React.useState(0);
    const [rows, setRows] = React.useState(0);
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [selectedList, setSelectedList] = React.useState<number[]>([]);


    function isContained(id: number): boolean {
        return selectedList.includes(id);
    }


    function checkPrescription(prescription: Prescription) {
        if (!isContained(prescription.id)) {
            setSelectedList(selectedList.concat([prescription.id]))

        }
        else {
            let index = selectedList.indexOf(prescription.id);
            let list = selectedList.slice(0, index).concat(
                selectedList.slice(index + 1, selectedList.length)
            )
            setSelectedList(list);
        }
    }

    

    async function loadMore() {
        const criteria: PagenatedRequest = {
            modelName: 'prescription',
            returnType: 'list',
            crieteria: {},
            limit: 20,
            page
        }
   
        const ans = await api.getModelList<Prescription>(criteria);
        return ans.data;
    }
    const { data, isFetching, refetch, isError } = useQuery('load-prescriptions', loadMore);

    function onDialogClose(event: {}, reason: "backdropClick" | "escapeKeyDown" | "buttonClick", ans: number) {
        if (loading) return;
        setOpen(false);
        if (ans === 2) {
          let items = selectedList.map(v => ({ id: v }));
          deleteModels(items)
    
        }
        console.log(event, reason, ans);
      }

      const deleteModels = async (ids: Array<{ id: number }>) => {
        setLoading(true);
        await api.deleteModels({modelName:  "prescription", ids});
        setSelectedList([]);
        setPage(1);
        refetch();

      }


      React.useEffect(() => {
        if (isFetching) return;
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);
    React.useEffect(() => {
        if(isError) {
         dispatch(putMessage({type: 'error', message: 'Failed to load LGA data'}))
     }}
     // eslint-disable-next-line react-hooks/exhaustive-deps
     , [isError])
    React.useEffect(() => {
        if (!data) return;
        let ans = data!.data;
        if (ans) {
            setPrescriptions(ans.payload);
            setTotal(ans.total);
            setRows(ans.rows);
        }
    }, [data]);

    const loader = <LinearProgress />;

    const body = (
        <TableBody>
            {prescriptions.map((item, index) => (
                <PrescriptionListWidget key={'prescription-' + index} prescription={item} onClickCheck={checkPrescription} active={isContained(item.id)} />
            ))}
        </TableBody>
    );

    return (
        <Box padding="1em">
    <DeleteDialog open={open} title="Delete Prescriptions" body={
        `Are you sure you want to delete ***${pluralize('Prescription', selectedList.length, true)}***, They will be  **deleted** and removed removed forever`
      }
        loading={loading}
        onClose={onDialogClose} />
            <Toolbar
                sx={{
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                    ...(selectedList.length > 0 && {
                        bgcolor: (theme) =>
                          alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                      }),
                }}
            >
                    {selectedList.length > 0 ? (
              <Typography
                sx={{ flex: '1 1 100%' }}
                color="inherit"
                variant="subtitle1"
                component="div"
              >
                {selectedList.length} selected
              </Typography>
            ) : (
                    <Box display="flex" sx={{ flex: '1 1 100%' }} alignItems={'center'}>
                        <IconButton disabled={page === 1}

                            onClick={() => {
                                setPage(page - 1)
                            }}
                        >
                            <ChevronLeftIcon />
                        </IconButton>
                        <Typography


                            id="tableTitle"
                            fontSize={'12px'}

                        >
                            {((page - 1) * (20)) + 1} to {((page * 20) > total) ? total : (page * 20)} of {total}
                        </Typography>
                        <IconButton disabled={page === rows}

                            onClick={() => {
                                setPage(page + 1)
                            }}
                        >
                            <ChevronRightIcon />
                        </IconButton>
                    </Box>
            )}
             {(!!selectedList.length) && (
               <Tooltip title="Delete">
               <IconButton onClick={() => {
            setOpen(true)
          }}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            )}
            
            </Toolbar>
            {isFetching && loader}
            <TableContainer  >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Title</TableCell>
                            <TableCell align="right">Status </TableCell>

                            <TableCell align="right">Amount(NGN)</TableCell>
                            <TableCell align="right">Paid For</TableCell>


 
                        </TableRow>
                    </TableHead>

                    { body}
                </Table>

            </TableContainer>

     
            
        </Box>
    )
}

export default PrescriptionsPage